import { render } from "./Upload.vue?vue&type=template&id=496e7caa&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=496e7caa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496e7caa"]])

export default __exports__